import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "utils/store";
import { forwardRef, useEffect, useRef, useState } from "react";
import { apiWrapper } from "apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { Group, Layer, Rect, Stage, Text, Image, Transformer } from "react-konva";
import { API_HOST } from "Constants";
import { connectRealtimeBoundaryAreaWebSocket } from "websock/realtimeBoundaryAreaManager";
import { useReactToPrint } from 'react-to-print';
import { getDateTime } from "utils/date";
import FireOnToolbar from "./FireOnToolbar";

//경계구역일람도
export default function BoundaryMapComponent(props) {
    const { id } = useParams();
    const searchParams = new URLSearchParams(window.location.search);
    const initFloorLevel = searchParams.get('floorLevel');
    const initFloor = searchParams.get('floor');
    const [floorLevel, setFloorLevel] = useState(initFloorLevel);
    const [floor, setFloor] = useState(initFloor);
    const isEdit = initFloorLevel !== null;
    const [floors, setFloors] = useState([]);
    const printRef = useRef();
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    useEffect(() => {
        //건물 상세 현황 조회 - 조회모드일 때 층수 설정하기 위함
        if (isEdit === false) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.getBuildingDetail(id);
                if (status === true) {
                    if (data.floors.length > 0) {
                        //첫번째 층으로 설정
                        setFloorLevel(data.floors[0].floorLevel);
                    }
                    setFloors(data.floors.map(item => {
                        return {
                            floorLevel: item.floorLevel,
                            floor: item.floor,
                        }
                    }));
                } else {
                    alert(`${data}`);
                }
            });
        }
    }, [id, isEdit]);

    const handleChangeFloorLevel = (floorLevel) => {
        setFloorLevel(floorLevel);
    }

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "경계구역일람도",
    });

    return (
        <>
            <div class="viewBoard fireOnBoard BMboard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard isEdit={isEdit} floorLevel={floorLevel} floor={floor} floors={floors} handleChangeFloorLevel={handleChangeFloorLevel} handlePrint={handlePrint} />
                <MapBoard printRef={printRef} isEdit={isEdit} floorLevel={floorLevel} />
                <FireOnToolbar item="경계구역일람도" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <Link className="set_contr" to="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">경계구역일람도</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

const MidBoard = ({ isEdit, floorLevel, floor, floors, handleChangeFloorLevel, handlePrint }) => {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;
    const [selectedFloor, setSelectedFloor] = useState(null);
    const [isListOpen, setIsListOpen] = useState(false);

    useEffect(() => {
        setSelectedFloor(floors.length > 0 ?
            {
                floorLevel: floors[0].floorLevel,
                floor: floors[0].floor
            }
            : null);
    }, [floors]);

    const toggleSelectBox = () => {
        setIsListOpen(!isListOpen);
    };

    const handleItemClick = (item) => {
        handleChangeFloorLevel(item.floorLevel);

        setSelectedFloor(item);
        setIsListOpen(false);
    }

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le" style={{ display: 'flex' }}>
                <p className="title_mid">{isEdit ? `${buildingName} (${floor})` : buildingName}</p>
                {isEdit === false && (
                    <div class="wrap_search openSearch" style={{ marginLeft: '10px', width: '110px' }}>
                        <div class="box_search">
                            <div className={`select_box ${isListOpen ? "open" : ""}`}>
                                <button className="btn_select" onClick={toggleSelectBox}>
                                    <p>{selectedFloor === null ? null : selectedFloor.floor}</p>
                                    <i class="x-icon"></i>
                                </button>
                                <ul class="list_member">
                                    {floors.length > 0 &&
                                        floors.map(
                                            (item, index) => (
                                                <li onClick={() => handleItemClick(item)}>
                                                    <p>{item.floor}</p>
                                                </li>
                                            )
                                        )}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="wrap_right">
                <div className="wrap_item_contr">
                    <div className="building_info">
                        <div className="item_info">
                            <p className="txt_info title_info">일련번호</p>
                            <p className="txt_info code_info">{serialNumber}</p>
                        </div>
                        <div className="item_info">
                            <p className="txt_info title_info">DEI 코드</p>
                            <p className="txt_info code_info">{dei}</p>
                        </div>
                    </div>
                    {isEdit === false && (
                        <button class="btn_contr btn_del" onClick={handlePrint}>
                            인쇄
                        </button>
                    )}
                </div>
            </div>
        </div >
    );
};

const MapBoard = forwardRef(({ printRef, isEdit, floorLevel }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const rectId = useRef(1);
    const mapBoardRef = useRef();
    const mapViewRef = useRef();
    const prevMapViewRef = useRef({
        width: 0,
        height: 0
    });
    const stageRef = useRef();
    const transformerRef = useRef();
    const iconImages = useRef({}); // 아이콘 이미지들을 별도의 ref에 저장
    const [mapViewSize, setMapViewSize] = useState({
        width: 0,
        height: 0,
    })
    const [equipments, setEquipments] = useState([]);
    const [shapes, setShapes] = useState([]);
    const shapesRef = useRef(shapes);
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [selectedShapeId, setSelectedShapeId] = useState(null);
    const [ledStatus, setLedStatus] = useState(null);

    // 회로 배열 초기화
    const boundaries = [...Array(20)].map((_, index) => ({
        name: `회로 ${index + 1}`,
        shapeType: "rectangle",
        backgroundColor: (
            index === 0 ? "rgba(233, 112, 49)" :
                index === 1 ? "rgba(21, 95, 130)" :
                    index === 2 ? "rgba(24, 107, 35)" :
                        index === 3 ? "rgba(156, 30, 142)" :
                            index === 4 ? "rgba(66, 162, 32)" : null
        ),
    }));

    useEffect(() => {
        //회로 상태 실시간 확인 소켓 연결
        connectRealtimeBoundaryAreaWebSocket(id, (data) => {
            setLedStatus(data.ledStatus);
            updateBoundariesStatus(data.ledStatus);
        });

        // 아이콘 배열 초기화
        apiWrapper(async () => {
            const { status, data } = await fireonApi.getBoundaryZoneMdbList();
            if (status === true) {
                const equipments = data.map(item => {
                    return {
                        src: API_HOST + item.iconImage,
                        name: item.name,
                        shapeType: "icon",
                    }
                });
                setEquipments(equipments);

                // 이미지 로드 후 iconImages에 저장
                equipments.forEach((item) => {
                    const image = new window.Image();
                    image.src = item.src;
                    image.crossOrigin = 'anonymous';
                    image.onload = () => {
                        iconImages.current[item.name] = image; // 아이콘 이름을 키로 사용해 이미지 저장
                    };
                    image.onerror = () => {
                        console.error(`Failed to load image: ${item.src}`);
                    };
                });
            } else {
                alert(`${data}`);
            }
        })

        //창 크기 변경 이벤트 등록 및 해제
        const handleResize = () => {
            resetMapViewSize();
            resetShapesSize();
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        if (id && floorLevel !== null) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.getBoundaryZone(id, floorLevel);
                if (status === true) {
                    //층별 평면도가 없으면 에러
                    if (data.floorPlanImage === null) {
                        alert("층별 평면도가 존재하지 않습니다.\n건물 상세 현황 페이지에서 층별 평면도를 등록해주세요.");
                    } else {
                        const img = new window.Image();
                        img.src = API_HOST + data.floorPlanImage;
                        img.crossOrigin = 'anonymous';

                        img.onload = () => {
                            setBackgroundImage(img);
                        };

                        img.onerror = (error) => {
                            console.error("이미지 로드 실패:", error);
                        };

                        //JSON 파싱
                        if (data.isExistBoundaryAreaSetting) {
                            const shapes = JSON.parse(data.boundaryAreaSetting);
                            const newShapes = shapes.map((shape) => {
                                const newShape = { ...shape };

                                //rectId 업데이트
                                rectId.current = parseInt(shape.id) + 1;

                                //이미지 URL -> img 변환
                                if (shape.imageSrc) {
                                    const img = new window.Image();
                                    img.src = shape.imageSrc;
                                    img.crossOrigin = 'anonymous';

                                    newShape.image = img;
                                }

                                //2026-02-09 이전에 저장된 데이터는 상대좌표가 없으므로 추가
                                const stageWidth = stageRef.current.width();
                                const stageHeight = stageRef.current.height();
                                newShape.relativeX = shape.relativeX ? shape.relativeX : shape.x / stageWidth;
                                newShape.relativeY = shape.relativeY ? shape.relativeY : shape.y / stageHeight;
                                newShape.relativeWidth = shape.relativeWidth ? shape.relativeWidth : shape.width / stageWidth;
                                newShape.relativeHeight = shape.relativeHeight ? shape.relativeHeight : shape.height / stageHeight;

                                return newShape;
                            });
                            setShapes(newShapes);
                        } else {
                            setShapes([]);
                        }
                    }
                }
            });
        }
    }, [floorLevel]);

    useEffect(() => {
        updateBoundariesStatus(ledStatus);
    }, [ledStatus]);

    const updateBoundariesStatus = (ledStatus) => {
        if (ledStatus !== null) {
            boundaries.map((item, index) => {
                //회로1~20 중 회로1~5까지만 존재함
                if (index < 5) {
                    //data[3]~[7]이 회로1~5이므로 index + 3
                    item.backgroundColor = ledStatus[index + 3] === 1 ? "red" : item.backgroundColor;
                }
            });
        }
    }

    useEffect(() => {
        const mapViewRect = mapViewRef.current.getBoundingClientRect();
        prevMapViewRef.current = {
            width: mapViewRect.width,
            height: mapViewRect.height,
        };

        resetMapViewSize();
    }, [mapViewRef.current]);

    useEffect(() => {
        shapesRef.current = shapes;
    }, [shapes]);

    const resetMapViewSize = () => {
        if (mapViewRef.current) {
            setMapViewSize({
                width: mapViewRef.current.offsetWidth,
                height: mapViewRef.current.offsetHeight,
            });
        }
    }

    const resetShapesSize = () => {
        if (shapesRef.current) {
            const currentMapViewWidth = mapViewRef.current.offsetWidth;
            const currentMapViewHeight = mapViewRef.current.offsetHeight;

            const prevMapViewWidth = prevMapViewRef.current.width;
            const prevMapViewHeight = prevMapViewRef.current.height;

            const widthDiff = currentMapViewWidth - prevMapViewWidth;
            const heightDiff = currentMapViewHeight - prevMapViewHeight;

            setShapes((prevShapes) =>
                prevShapes.map((shape) => {
                    const newX = shape.relativeX * currentMapViewWidth;
                    const newY = shape.relativeY * currentMapViewHeight;

                    return {
                        ...shape,
                        x: widthDiff < 0 ? newX + widthDiff * shape.relativeX : newX,
                        y: heightDiff < 0 ? newY + heightDiff * shape.relativeY : newY,
                        width: shape.relativeWidth * currentMapViewWidth,
                        height: shape.relativeHeight * currentMapViewHeight,
                    };
                }));

            prevMapViewRef.current = { width: currentMapViewWidth, height: currentMapViewHeight };
        }
    }

    const handleDragStart = (shapeItem) => (e) => {
        e.dataTransfer.setData("shapeItem", JSON.stringify(shapeItem));
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // 드래그 중 기본 동작 방지
    };

    const handleDrop = (e) => {
        e.preventDefault(); // 기본 동작 방지

        stageRef.current.setPointersPositions(e);

        const shapeItem = JSON.parse(e.dataTransfer.getData("shapeItem"));
        const pos = stageRef.current.getPointerPosition(); // 마우스 위치 가져오기
        const stageWidth = stageRef.current.width();
        const stageHeight = stageRef.current.height();

        // 드롭된 아이템의 이름으로 해당 이미지 찾기
        const droppedImage = iconImages.current[shapeItem.name];
        const droppedImageSrc = typeof droppedImage === 'undefined' ? droppedImage : droppedImage.src;

        setShapes((prevShapes) => [
            ...prevShapes,
            {
                x: pos.x - 50,
                y: pos.y - 25,
                width: 100,
                height: 100,
                relativeX: (pos.x - 50) / stageWidth,
                relativeY: (pos.y - 25) / stageHeight,
                relativeWidth: 100 / stageWidth,
                relativeHeight: 100 / stageHeight,
                id: rectId.current.toString(), // 현재 rectId 사용,
                type: shapeItem.shapeType,
                name: shapeItem.name,
                backgroundColor: shapeItem.backgroundColor,
                image: droppedImage,
                imageSrc: droppedImageSrc,
            },
        ]);

        rectId.current += 1; // rectId 증가
    };

    const handleContextMenu = (e, shape) => {
        e.evt.preventDefault(); // 기본 컨텍스트 메뉴 방지
        const mapboardRect = mapBoardRef.current.getBoundingClientRect();
        const containerRect = stageRef.current.container().getBoundingClientRect();
        const pos = stageRef.current.getPointerPosition(); // 마우스 위치 가져오기
        setMenuPosition({ x: containerRect.left + pos.x - mapboardRect.left, y: containerRect.top + pos.y - mapboardRect.top }); // 마우스 위치 저장
        setSelectedShapeId(shape.id); // 선택된 항목 ID 저장
        setContextMenuVisible(true); // 사용자 정의 메뉴 표시
    };

    const handleTransformEnd = (e) => {
        const id = e.target.id();
        const node = e.target;

        const newShapes = shapes.map((shape) => {
            if (id === "G" + shape.id) {
                const scaleX = node.scaleX();
                const scaleY = node.scaleY();
                const stageWidth = stageRef.current.width();
                const stageHeight = stageRef.current.height();

                // Reset scale
                node.scaleX(1);
                node.scaleY(1);

                // Update the state with new values
                return {
                    ...shape,
                    x: node.x(),
                    y: node.y(),
                    width: Math.max(5, node.width() * scaleX),
                    height: Math.max(5, node.height() * scaleY),
                    relativeX: node.x() / stageWidth,
                    relativeY: node.y() / stageHeight,
                    relativeWidth: Math.max(5, node.width() * scaleX) / stageWidth,
                    relativeHeight: Math.max(5, node.height() * scaleY) / stageHeight,
                    rotation: node.rotation(),
                };
            }
            return shape;
        })
        setShapes(newShapes);
    }

    const handleDeleteShape = () => {
        if (selectedShapeId) {
            setShapes(shapes.filter((shape) => shape.id !== selectedShapeId));
            transformerRef.current.nodes([]);
            transformerRef.current.getLayer().batchDraw(); // 레이어 업데이트
            setSelectedShapeId(null); // 선택 해제
            setContextMenuVisible(false); // 메뉴 숨기기
        }
    };

    const handleCloseMenu = () => {
        setContextMenuVisible(false); // 메뉴 숨기기
        setSelectedShapeId(null); // 선택 해제
    };

    const handleSelectShape = (id) => {
        var rectRef = stageRef.current.findOne(`#G${id}`);
        transformerRef.current.nodes([rectRef]); // 선택된 도형 인스턴스를 설정
        transformerRef.current.getLayer().batchDraw(); // 레이어 업데이트
    };

    const handleStageClick = (e) => {
        // 클릭한 대상이 배경일 때만 선택 해제
        if (e.target.attrs.id === "img") {
            transformerRef.current.nodes([]); // 선택된 도형 없애기
            transformerRef.current.getLayer().batchDraw();
        }
    };

    const handleCancel = () => {
        navigate(-1);
    }

    const handleSave = async (e) => {
        const imageSrc = stageRef.current.toDataURL();

        //이미지 URL -> Blob 변환
        try {
            const response = await fetch(imageSrc);
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }

            const blob = await response.blob();
            const filename = `${getDateTime(new Date()).replace(/ /g, '').replace(/-/g, '').replace(/:/g, '')}_${id}_${floorLevel}.png`;
            const file = new File([blob], filename, { type: blob.type });

            apiWrapper(async () => {
                let requestBody = new FormData();
                console.log(file)
                requestBody.append("boundaryPreviewImage", file);
                requestBody.append("data",
                    JSON.stringify({
                        boundaryAreaSetting: JSON.stringify(shapes)
                    }));

                const { status, data } = await fireonApi.updateBoundaryZone(id, floorLevel, requestBody);
                alert(`${data}`);

                if (status === true) {
                    //성공 시 뒤로가기
                    navigate(-1);
                }
            })
        } catch (error) {
            console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
        }
    }

    const convertRgbaText = (text) => {
        text = text.replace("rgba(", "");
        text = text.replace(")", "");
        text = text.replace(" ", "");
        var rgba = text.split(",");

        const r = rgba[0];
        const g = rgba[1];
        const b = rgba[2];

        return `${r}, ${g}, ${b}`;
    }

    return (
        <>
            <div ref={mapBoardRef} className="map_board">
                <div className="map_inner_wrap">
                    <div className="wrap_legend">
                        <div className="box_boundaryLegend">
                            <p className="title_legend">경계구역 범례</p>
                            <div className="wrap_blBtn">
                                {boundaries.length > 0 &&
                                    boundaries.map((item, index) => (
                                        <button
                                            key={index}
                                            className="item_blBtn"
                                            style={{ cursor: isEdit === true ? "grab" : "default", backgroundColor: item.backgroundColor }}
                                            onDragStart={handleDragStart(item)}
                                            draggable={isEdit === true}
                                        >
                                            {item.name}
                                        </button>
                                    ))}
                            </div>
                        </div>
                        <div className="box_fireEquipmentLegend">
                            <p className="title_legend">소방설비 범례</p>
                            <div className="wrap_felBtn">
                                {equipments.length > 0 &&
                                    equipments.map((item, index) => (
                                        <button
                                            key={index}
                                            className="item_felBtn"
                                            style={{ cursor: isEdit === true ? "grab" : "default" }}
                                            onDragStart={handleDragStart(item)}
                                            draggable={isEdit === true}
                                        >
                                            <div className="img_felBtn">
                                                {item.src && <img src={item.src} alt={item.name} />}
                                            </div>
                                            <p className="title_felBtn">{item.name}</p>
                                        </button>
                                    ))}
                            </div>
                        </div>
                    </div>

                    <div ref={mapViewRef} className="wrap_mapView" onDrop={handleDrop} onDragOver={handleDragOver} >
                        <div ref={printRef} >
                            <Stage
                                ref={stageRef}
                                width={mapViewSize.width}
                                height={mapViewSize.height}
                                className="img_wrap"
                                onMouseDown={handleStageClick}
                            >
                                <Layer>
                                    {backgroundImage && (
                                        <Rect
                                            id="img"
                                            x={0}
                                            y={0}
                                            width={mapViewSize.width}
                                            height={mapViewSize.height}
                                            fillPatternScaleX={mapViewSize.width / backgroundImage.width}
                                            fillPatternScaleY={mapViewSize.height / backgroundImage.height}
                                            fillPatternImage={backgroundImage} // 배경 이미지 설정
                                            fillPatternRepeat="no-repeat"
                                        />
                                    )}
                                    {shapes.map((shape) => (
                                        <Group
                                            id={"G" + shape.id}
                                            key={shape.id}
                                            x={shape.x}
                                            y={shape.y}
                                            onMouseDown={() => {
                                                if (isEdit === false)
                                                    return;
                                                handleSelectShape(shape.id);
                                            }}
                                            onTab={() => {
                                                if (isEdit === false)
                                                    return;
                                                handleSelectShape(shape.id);
                                            }}
                                            onContextMenu={(e) => {
                                                if (isEdit === false)
                                                    return;
                                                handleContextMenu(e, shape); // 오른쪽 클릭 핸들러
                                            }}
                                            onDragMove={(e) => {
                                                const newShapes = shapes.map((s) => {
                                                    if (s.id === shape.id) {
                                                        const stageWidth = stageRef.current.width();
                                                        const stageHeight = stageRef.current.height();
                                                        return {
                                                            ...s,
                                                            x: e.target.x(),
                                                            y: e.target.y(),
                                                            relativeX: e.target.x() / stageWidth,
                                                            relativeY: e.target.y() / stageHeight,
                                                        };
                                                    }
                                                    return s;
                                                });
                                                setShapes(newShapes);
                                            }}
                                            onDragEnd={(e) => {
                                                const newShapes = shapes.map((s) => {
                                                    if (s.id === shape.id) {
                                                        const stageWidth = stageRef.current.width();
                                                        const stageHeight = stageRef.current.height();
                                                        return {
                                                            ...s,
                                                            x: e.target.x(),
                                                            y: e.target.y(),
                                                            relativeX: e.target.x() / stageWidth,
                                                            relativeY: e.target.y() / stageHeight,
                                                        };
                                                    }
                                                    return s;
                                                });
                                                setShapes(newShapes);
                                            }}
                                            onMouseEnter={(e) => {
                                                if (isEdit === false)
                                                    return;
                                                e.target.getStage().container().style.cursor = "pointer"; // 마우스가 올라갔을 때 손 모양 커서
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.getStage().container().style.cursor = "default"; // 마우스가 나갔을 때 기본 커서
                                            }}
                                            width={shape.width}
                                            height={shape.height}
                                            onTransformEnd={handleTransformEnd}
                                            draggable={isEdit === true}
                                        >
                                            {shape.type === "rectangle" ? (
                                                <>
                                                    <Rect
                                                        id={"R" + shape.id}
                                                        key={shape.id}
                                                        width={shape.width}
                                                        height={shape.height}
                                                        stroke={shape.backgroundColor ? shape.backgroundColor : "red"}
                                                        strokeWidth={8}
                                                        fill={
                                                            shape.backgroundColor
                                                                ? `rgba(${convertRgbaText(shape.backgroundColor)}, 0.5)`
                                                                : "rgba(255, 0, 0, 0.5)"
                                                        }
                                                        cornerRadius={20}
                                                        strokeScaleEnabled={false}
                                                    />
                                                    <Text
                                                        id={"T" + shape.id}
                                                        text={shape.name}
                                                        width={shape.width}
                                                        height={shape.height}
                                                        fontSize={32}
                                                        fill="white" // 텍스트 색상
                                                        align="center" // 텍스트 수평 정렬
                                                        verticalAlign="middle" // 텍스트 수직 정렬
                                                        padding={0} // 텍스트 패딩
                                                        lineHeight={1.2} // 줄 간격 조정
                                                    />
                                                </>
                                            ) : shape.type === "icon" ? (
                                                <>
                                                    <Image
                                                        id={"I" + shape.id}
                                                        width={shape.width}
                                                        height={shape.height}
                                                        image={shape.image}
                                                    ></Image>
                                                </>
                                            ) : null}
                                        </Group>
                                    ))}
                                    <Transformer
                                        ref={transformerRef}
                                        rotateEnabled={true}
                                        resizeEnabled={true}
                                        keepRatio={false} // 비율 유지하지 않도록 설정
                                        ignoreStroke={true} //storke 제외하고 선택영역 그림
                                        rotationSnaps={[0, 90, 180, 270]}
                                    />
                                </Layer>
                            </Stage>
                        </div>
                    </div>
                    {contextMenuVisible && (
                        <div
                            style={{
                                position: "absolute",
                                top: menuPosition.y,
                                left: menuPosition.x,
                                backgroundColor: "white",
                                border: "1px solid black",
                                zIndex: 1000,
                            }}
                            onMouseLeave={handleCloseMenu} // 메뉴에서 마우스가 나가면 닫기
                        >
                            <ul onClick={handleDeleteShape} style={{ margin: 0, padding: "5px 10px" }}>
                                <li style={{ cursor: "pointer" }}>
                                    삭제
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>

            {isEdit === true && (
                <div className="wrap_controll type-start type-black">
                    <div className="wrap_btn_set">
                        <button className="btn_set btn_cancle" onClick={handleCancel}>취소</button>
                        <button className="btn_set btn_save" onClick={handleSave} >저장</button>
                    </div>
                </div>
            )}
        </>
    );
});